import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { ApiCache, GET_SEO_URLS_API_CACHE_KEY } from './apiCache';
import { IGetUriRequest, TGetUriResponse, fetchGetUri } from '../repositories/seo-urls/v1/get-uri';

/**
 * null — у фильтров нет ЧПУ, undefined — запрос не удался.
 * Сбой нельзя путать с отсутствием ЧПУ: на маунте выдачи он не должен уводить URL с ЧПУ.
 */
export async function getSeoUrls(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: IGetUriRequest,
  seoApiCacheEnabled?: boolean,
): Promise<string | null | undefined> {
  try {
    const cacheKey = `${GET_SEO_URLS_API_CACHE_KEY}_${parameters.query}`;
    if (seoApiCacheEnabled) {
      const cacheData = ApiCache.getData<string | null>(cacheKey);
      if (typeof cacheData !== 'undefined') {
        return cacheData;
      }
    }

    const { response, statusCode }: TGetUriResponse = await fetchGetUri({
      httpApi,
      parameters,
    });

    if (statusCode !== 200 || 'errors' in response) {
      throw response;
    }

    const result = response.uri ?? null;

    if (seoApiCacheEnabled) {
      ApiCache.setData(cacheKey, result);
    }

    return result;
  } catch (error) {
    logger.error(error, { message: 'Error in getUri' });

    return undefined;
  }
}
